import { applyFilters, doRequest } from "./helpers";

export default class MetaSandboxCampaignService {
  static async list(accountId, filters = null) {
    let path = `/meta_ad_account/${accountId}/sandbox/campaigns`;
    path = applyFilters(filters, path);
    return doRequest("GET", path);
  }
}
